import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { SliderLayout as SliderLayoutComponent } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function SliderLayout() {
	return {
		componentName: 'VisibilityLayout',
		componentGroup: 'SliderLayout',
		componentId: uuidv4(),
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Slider Layout (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow({ mzTitle: 'MZ | Banner', blockClass: 'slider-layout-3__flex-row', colSizing: 'equal' }, [
				StoreImageList(
					{
						height: 'auto',
						images: [
							{
								image: 'https://hefesto-upload-images.s3.amazonaws.com/1683045642921-sliderLayout-2-desktop.png',
								mobileImage: 'https://hefesto-upload-images.s3.amazonaws.com/1683045718304-sliderLayout-2-mobile-2.png',
								description: 'Imagem',
							},
							{
								image: 'https://hefesto-upload-images.s3.amazonaws.com/1683045642921-sliderLayout-2-desktop.png',
								mobileImage: 'https://hefesto-upload-images.s3.amazonaws.com/1683045718304-sliderLayout-2-mobile-2.png',
								description: 'Imagem2',
							},
						],
					},
					[
						SliderLayoutComponent({
							usePagination: true,
							mzTitle: 'Layout do slider',
							blockClass: 'home__slider-3',
							arrowSize: {
								desktop: 25,
								tablet: 25,
								phone: 25,
							},
							slideTransition: {
								speed: 400,
								delay: 0,
							},
							fullWidth: true,
						}),
					],
				),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{
				from: '--white',
				to: '--slider-3-arrow-color',
				name: 'Arrow',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--slider-3-arrow-background',
				name: 'Slider',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--slider-3-dots',
				name: 'Dots',
			},
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--slider-3-border-radius', name: 'Raio borda Slider' }],
	},
	{
		type: 'fontSize',
		list: [{ from: '--font-size-md', to: '--slider-3-arrow-icon-size', name: 'Tamanho ícone Arrow' }],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-md', to: '--slider-3-arrow-size', name: 'Tamanho Arrow' },
			{ from: '--spacing-sm', to: '--slider-3-dot-width', name: 'Largura Dot' },
			{ from: '--spacing-sm', to: '--slider-3-dot-width-active', name: 'Largura Dot Active' },
			{ from: '--spacing-xxs', to: '--slider-3-dot-height', name: 'Altura Dot' },
			{ from: '--spacing-xxs', to: '--slider-3-dot-height-active', name: 'Altura Dot Active' },
			{ from: '--spacing-xxs', to: '--slider-3-dots-container-spacing', name: 'Espaçamento Dot' },
			{ from: '--spacing-xxl', to: '--slider-3-dots-bottom', name: 'Margem inferior Dots' },
		],
	},
];
